module.exports = __webpack_public_path__ + "back.svg?9fb67f452bd3075e81ad57e422a4ba78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/back.svg
// module id = 105
// module chunks = 0